import React from 'react';
import useStyles from './IdentityConfirmationNeededPageStyles';
import {useLocation} from 'react-router';
import {Box, Grid} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import i18nNamespaces from '../../const/i18nNamespaces';
import {ConfirmIdentityImage} from '../../assets';

const IdentityConfirmationNeededPage = () => {
    const classes = useStyles();
    const location = useLocation<{afterRegistration: boolean}>();
    const {t} = useTranslation(i18nNamespaces.AUTH);

    return (
        <Grid
            container
            className={classes.container}
            direction={'column'}
            alignItems={'center'}
        >
            <Box className={classes.title}>
                {location?.state?.afterRegistration
                    ? t('thankYou')
                    : t('identityApproveNeeded')}
            </Box>
            <Box className={classes.subtitle}>
                {t('employeeWillContactYou')}
            </Box>
            <img src={ConfirmIdentityImage} />
        </Grid>
    );
};

export default IdentityConfirmationNeededPage;
